import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from 'prop-types';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';

// 0 -> Felvitel
// 1 -> módosítás
let _muvelet = 0;
let _modositoObj = null;

class InflacioLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalFelvitel: false,
      modalTorles: false,
      dataLoaded: false,
      dataFailed: false,
      baseJson: [],
      aktivTipusok: [],
      aktivStatuszok: [],
      statusz: [],
      statuszOptions: [],
      tipus: [],
      tipusOptions: [],
      filterOptions: {},
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.updateTable = this.updateTable.bind(this);
  }

  componentDidMount() {
    this.updateTable();
  }

  /** Dinamikusan töltendő szűkítő feltételek lekérdezése */
  // getEnums = () => {
  //   Services.listInflacioEnums((err, res) => {
  //     if (!err) {
  //       let aktivTipusok = res[0][0].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
  //       let aktivStatuszok = res[0][1].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
  //       this.setState({
  //         aktivTipusok: aktivTipusok,
  //         aktivStatuszok: aktivStatuszok
  //       });
  //     }
  //   });
  // }

  /** Objektumot bejárva az üres stringeket NULL-ra állítja */
  emptyToNull = (obj) => {
    if (!obj || typeof obj !== 'object') return;
    for (let p in obj) {
      if (typeof obj[p] === 'object' && obj[p] !== null) {
        this.emptyToNull(obj[p]);
      } else if (obj.hasOwnProperty(p)) {
        if (obj[p] === '' || obj[p] === undefined) {
          obj[p] = null;
        }
      }
    }
  }

  updateTable = () => {
    this.setState({ dataLoaded: false, dataFailed: false });

    Services.listInflacio((err, res) => {
      if (err) {
        this.setState({ dataLoaded: true, dataFailed: true });
      } else {
        let filters = {};
        let statuszOptions = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });
        let tipusOptions = res[0].tipus.map(e => <option key={e.name} value={e.name}>{e.caption}</option>);

        this.setState({
          baseJson: res[0].list,
          statuszOptions: statuszOptions,
          statusz: res[0].statusz,
          tipusOptions: tipusOptions,
          tipus: res[0].tipus,
          filterOptions: filters,
          dataLoaded: true,
          dataFailed: false
        });
      }
    });
  }

  fillModositoObj = () => {
    this.setState({ modifyDataLoaded: false, modfiyDataFailed: false });

    Services.getInflacio(this._currentEditId, (err, res) => {
      if (err) {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: true });
      } else {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: false });
        res[0].felhasznalva ? res[0].felhasznalva = 'true' : res[0].felhasznalva = 'false';
        _modositoObj = res[0];
        this.toggleFelvitel();
      }
    });
  }

  clearModositoObj = () => {
    _modositoObj = {
      id: '',
      ev: '',
      tipus: '',
      mertek: '',
      statusz: ''
    };
  }


  toggleFelvitel = () => {
    this.setState({ modalFelvitel: !this.state.modalFelvitel });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  handleEditClick = (id) => {
    _muvelet = 1;
    this._currentEditId = id;
    this.fillModositoObj();
  }

  handleNewClick = () => {
    _muvelet = 0;
    this.clearModositoObj();
    this.toggleFelvitel();
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        { this.props.globals.hasRole(['PENZUGYKOZOS_INFLACIO'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell} onClick={() => this.handleEditClick(cell, row)} />
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-edit-' + cell} delay={10}>
              Módosítás
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-delete-' + cell} delay={10}>
              Törlés
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  /**
  * Visszaadja az apartmanhoz tartozó státus jelvényeket.
  * @param {boolean} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
  */
  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  tipusFormatter = (cell) => {
    let tipus = this.state.tipus.find(x => x.name === cell);
    return tipus ? tipus.caption : 'N/A';
  }

  felhasznalvaFormatter = (cell) => {
    return cell ? 'Igen' : 'Nem';
  }

  addInflacio = (event, inflacioObj) => {
    this.emptyToNull(inflacioObj);
    this.setState({ addButtonLoading: true });
    Services.addInflacio(inflacioObj, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Infláció felvéve!');
      }
      this.setState({ addButtonLoading: false });
    });
  }

  updateInflacio = (event, inflacioObj) => {
    inflacioObj.id = this._currentEditId;
    this.setState({ modifyButtonLoading: true });
    Services.editInflacio(inflacioObj, this._currentEditId, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Infláció módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteInflacio = (id) => {
    this.toggleTorles();
    this.setState({ deleteButtonLoading: true });
    Services.deleteInflacio(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Infláció törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  filterType = (cell) => {
    // just return type for filtering or searching.
    return cell.caption;
  }

  renderTable = () => {
    const pagination = true;
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ],
    };

    const statusType = {
      AKTIV: 'Aktív',
      INAKTIV: 'Inaktív',
    };

    const columns = [
      {
        dataField: 'ev',
        text: 'Év',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'normal'
        },
      },
      {
        dataField: 'tipus',
        text: 'Típus',
        formatter: this.tipusFormatter,
        style: {
          whiteSpace: 'normal'
        },
      },
      {
        dataField: 'mertek',
        text: 'Infláció mértéke %',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'normal'
        },
      },
      {
        dataField: 'felhasznalva',
        text: 'Felhasználva',
        formatter: this.felhasznalvaFormatter,
        style: {
          whiteSpace: 'normal'
        },
      },
      {
        dataField: 'statusz',
        text: 'Státusz',
        formatter: this.statusFormatter,
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        align: 'center'
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter,
        hidden: !this.props.globals.hasRole(['PENZUGYKOZOS_INFLACIO'], true)
      },
    ];

    return this.state.baseJson.length ?
    <BootstrapTable
      bootstrap4
      keyField="id"
      columns={columns}
      data={this.state.baseJson}
      filter={filterFactory()}
      pagination={paginationFactory(Lib.bootstraptableProps)}
    /> : <DataEmptyState />;
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        { this.props.globals.hasRole(['PENZUGYKOZOS_INFLACIO'], true) && (
          <div className="row">
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>Új infláció</Button>
            </div>
          </div>
        )}
        {(this.state.dataLoaded && !this.state.dataFailed) ? this.renderTable() : (this.state.dataFailed) ? <NetworkEmptyState submitClick={this.updateTable} /> : this.renderLoader()}
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>
            Valóban törölni kívánod a kiválasztott tételt?
          </ModalBody>
          <ModalFooter>
            <ProgressButton className="btn-cursor-pointer" color="primary" loading={this.state.deleteButtonLoading} onClick={() => this.deleteInflacio(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalFelvitel} toggle={this.toggleFelvitel} className={this.props.className} backdrop="static" >
          <RFForm
            modal
            onSubmit={_muvelet === 0 ? this.addInflacio : this.updateInflacio}
            title={_muvelet === 0 ? "Új infláció rögzítése" : "Meglévő infláció módosítása" }
            footer={
              <>
                <ProgressButton color="primary" loading={_muvelet === 0 ? this.state.addButtonLoading : this.state.modifyButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleFelvitel} >Mégsem</Button>
              </>
            }
          >
            <RFField
              label="Év:"
              name="ev"
              required
              type="number"
              value={_modositoObj && _modositoObj.ev}
              min="1900"
              max="3000"
            />
            <RFField
              type="select"
              name="tipus"
              label="Típus:"
              required
              value={_modositoObj && _modositoObj.tipus && _modositoObj.tipus.name}
              defaultSelect={<option value="" >Válassz típust...</option>}
              selectOptions={this.state.tipusOptions}
            />
            <RFField
              label="Infláció mértéke %:"
              name="mertek"
              required
              type="number"
              value={_modositoObj && _modositoObj.mertek}
              min="0"
              max="100"
              step="0.01"
            />
            <RFField
              type="select"
              name="statusz"
              label="Státusz:"
              required
              value={_modositoObj && _modositoObj.statusz && _modositoObj.statusz.name}
              defaultSelect={<option value="" >Válassz státuszt...</option>}
              selectOptions={this.state.statuszOptions}
            />
            {_muvelet === 1 ? 
            <RFField
              type="select"
              name="felhasznalva"
              label="Felhasználva:"
              required
              disabled
              value={_modositoObj && _modositoObj.felhasznalva}
              selectOptions={
                <>
                  <option value="false">Nem</option>
                  <option value="true">Igen</option>
                </>
              }
            /> : <span /> }
          </RFForm>
        </Modal>
      </div>
    );
  }
}

InflacioLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object,
  className: PropTypes.string
};

export default InflacioLista;
